<template>
  <lu-hbox lu-flex lu-vcenter class="login-container"  >

    <lu-vbox class="login-form" v-if='!isNeedToChangePassword'>

      <el-form ref="loginForm" :model="loginForm" :rules="loginRules" auto-complete="on" label-position="left" >

        <lu-item class='loginLogo'  :style='loginLogoStyle' />

        <lu-hbox lu-vcenter class="login-title">
          <lu-item>{{ $t('Please input your login details') }}</lu-item>
        </lu-hbox>

        <el-form-item prop="login">
          <span class="svg-container">
            <svg-icon icon-class="user" />
          </span>
          <el-input
            ref="login"
            class='login-input'
            v-model="loginForm.login"
            placeholder="Login"
            name="login"
            type="text"
            tabindex="1"
            auto-complete="on"
          />
        </el-form-item>

        <el-form-item prop="password">
          <span class="svg-container">
            <svg-icon icon-class="password" />
          </span>
          <el-input
            :key="passwordType"
            class='login-input'
            ref="password"
            v-model="loginForm.password"
            :type="passwordType"
            placeholder="Password"
            name="password"
            tabindex="2"
            auto-complete="on"
            @keyup.enter.native="handleLogin"
          />
          <span class="show-pwd" @click="showPwd">
            <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
          </span>
        </el-form-item>
      </el-form>

      <lu-vbox lu-vcenter class='vpad-in-5 mar-t-10'>
        <lu-item><el-button :loading="loading" class='login-button' @click.native.prevent="handleLogin">{{ $t('Login') }}</el-button></lu-item>
        <lu-item v-if='showRegister' ><el-button :loading="loading" class='login-button' @click.native.prevent="handleRegister">{{ $t('Register') }}</el-button></lu-item>
        <lu-item lu-click style='padding-top: 20px;justify-content: center' class="login-text" @click='setForgotPwd'>{{ $t('Forgot Password') }}?</lu-item>
      </lu-vbox>

      <lu-hbox class='pad-in-20'>
        <lu-item lu-flex />
        <env-select class="set-language"/>
        <lang-select class="set-language"/>
      </lu-hbox>
    </lu-vbox>
    <lu-item class='mainLogo' :style='mainLogoStyle' lu-flex/>

    <el-dialog v-el-drag-dialog  title="Forgot Password" :visible.sync="forgotPwdVal" @close='closeForgotDialog'>
      <lu-vbox lu-hcenter class='dialog-container'>
        <lu-item class='loginLogo'></lu-item>

        <el-form ref="formQuery" :model="formQuery" :rules="pwRules" auto-complete="on" label-position="left" >
          <el-form-item label='Email' prop="email" style='width: 450px;'>
            <el-input v-model='formQuery.email' :placeholder="$t('Email')"/>
          </el-form-item>

          <lu-hbox lu-hcenter class='pad-in-5 mar-t-10'>
            <lu-item><el-button @click.native.prevent="handleForgotPwValid">{{ $t('Ok') }}</el-button></lu-item>
            <lu-item><el-button @click.native.prevent="handleForgotPwReset">{{ $t('Cancel') }}</el-button></lu-item>
          </lu-hbox>

        </el-form>
      </lu-vbox>
    </el-dialog>

     <ChangePwd v-if='isNeedToChangePassword' :userLogin='loginForm.login.trim()'/>

  </lu-hbox>
</template>

<script>
import { LuItem, LuHbox, LuVbox } from 'lusis-ui'
import LangSelect from '@/components/LangSelect'
import EnvSelect from '@/components/EnvSelect'
import { mapGetters, mapState, mapActions } from 'vuex'
import messageHandler from '@/mixins/message'
import variableHandler from '@/mixins/variables'
import elDragDialog from '@/directive/el-dragDialog'
import ChangePwd from './changePwd'
// import PageHeader from '@/components/PageHeader'
import logoImage from '@/assets/img/poweredByLusis.png'
// import Storage from '@/utils/storage'

export default {
  components: { LuItem, LuHbox, LuVbox, LangSelect, EnvSelect, ChangePwd },
  name: 'Login',
  mixins: [ messageHandler, variableHandler ],
  directives: { elDragDialog },
  data() {
    const validateUsername = (rule, value, callback) => {
      callback()
      /*
      if (!validLogin(value)) {
        callback(new Error('Please enter the correct user name'))
      } else {
        callback()
      }
      */
    }
    const validatePassword = (rule, value, callback) => {
      callback()
      // if (value.length < 3) {
      //   callback(new Error('The password can not be less than 3 digits'))
      // } else {
      //   callback()
      // }
    }

    return {
      logo: logoImage,
      loginForm: {
        login: '',
        password: ''
      },
      formQuery: {
        email: ''
      },
      loginRules: {
        login: [{ required: true, trigger: 'blur', validator: validateUsername }],
        password: [{ required: true, trigger: 'blur', validator: validatePassword }]
      },
      pwRules: {
        email: [
          { type: 'email', message: this.$t('Should be an email'), required: true }
        ]
      },
      loading: false,
      passwordType: 'password',
      redirect: undefined,
      forgotPwdVal: false,
      permississionBrokers: [],
      idx: -1
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  computed: {
    // loginLogo() {
    //   let configList = Storage.getItem('config')
    //   let loginLogo = ''
    //   if (configList && configList.length) {
    //     let idx = configList.findIndex(item => item.name === 'loginLogo')
    //     if (idx !== -1) loginLogo = configList[idx].data ? configList[idx].data : ''
    //   }
    //   return {
    //     'background-image': 'url(' + loginLogo + ')'
    //   }
    // },
    ...mapState({ showRegister: state => state.tangoEnv.showRegister }),
    ...mapGetters( [ 'tangoConfig', 'userPermission', 'isAdmin', 'tangoStatus', 'addedRouters', 'isNeedToChangePassword', 'userInfos', 'userPermissionBroker', 'instrumentList', 'accountList' ] )
  },
  methods: {
    ...mapActions('user', [ 'setNotificationList' ]),
    ...mapActions('iRiskMonitor', [ 'addInstrumentList', 'deleteInstrumentList', 'addAccountList', 'deleteAccountList' ]),
    showPwd() {
      this.passwordType = this.passwordType === 'password' ? '' : 'password'
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    setForgotPwd: function () {
      this.forgotPwdVal = !this.forgotPwdVal
    },
    closeForgotDialog: function () {
      this.$refs.formQuery.resetFields()
      this.$refs['formQuery'].clearValidate()
    },
    handleForgotPwReset: function () {
      this.$refs.formQuery.resetFields()
      this.$refs['formQuery'].clearValidate()
      this.setForgotPwd()
    },
    handleForgotPwValid: function () {
      this.$refs.formQuery.validate(valid => {
        if (valid) {
          this.connectToServer().then(server => server['forgotPassword'](this.formQuery.email)).then(rep => {
            if (rep.resultCode === 0) {
              this.$message({
                type: 'success',
                message: this.$t('Email has been successfully sent')
              })
              this.handleForgotPwReset()
            }
            else {
              throw new Error('user not exists')
            }
          }).catch(err => {
            this.$message({
              type: 'error',
              message: err.message
            })
          })
        }
      })
    },
    handleLogin() {
      if (!this.tangoConfig) return
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          /*
          if (this.tangoStatus !== 3) {
            return Promise.reject(new Error('Tango connection or Missing config'))
          }
          */
          const login = this.loginForm.login.trim()
          const password = this.loginForm.password.trim()
          return this.connectToServer().then(() => this.$tango.login(login, password)).then(rep => {
            if (rep.resultCode === 0) {
              this.loading = false
              this.$store.dispatch('user/login', rep)
              this.$store.dispatch('permission/GenerateRoutes', { roles: this.userPermission, isAdmin: this.isAdmin })
              this.$router.matcher.addRoutes(this.addedRouters)

              this.$router.push({ path: this.redirect || '/' })
              this.$tango.startHeartbeatTimer(this.userInfos.heartbeatDelay)

              // init getSymbolList / getAccountList
              this.deleteInstrumentList()
              this.deleteAccountList()
              if (this.userPermissionBroker !== null && this.userPermissionBroker != undefined) {
                this.permississionBrokers = this.userPermissionBroker.split('|').filter(b => b !== "")
                if (this.permississionBrokers && this.permississionBrokers.length) {
                  this.getSymbolList()
                }
              }

              //notifications
              this.getNotificationList()
            }
            else if (rep.resultCode === 18) {
              this.loading = false
              this.$store.commit('user/needToChangePassword', true)
              return
            }
            else if (rep.resultCode === 4) { // user already logged in
              this.logout()
              return
            } else {
              this.$store.dispatch('user/resetStore')
              this.$store.commit('RESET_STORE')
              return Promise.reject('Auth')
            }
          }).catch(err => {
            this.loading = false
            this.$message({
              message: err,
              type: 'error'
            })
            return false
          })
        }
      })
    },
    handleRegister() {
      this.connectToServer().then(() => {
        this.$router.push({ name: 'signup' }).catch(() => {})
      }).catch(err => {
        // eslint-disable-next-line handle-callback-err, no-console
        console.log(err)
        this.$message({
          type: 'error',
          message: this.$t('tango connection failed')
        })
      })
    },
    getCurrentPlatform(idx) {
      if (this.permississionBrokers && idx<this.permississionBrokers.length) {
        return this.permississionBrokers[idx]
      } else
        return ""
    },
    getSymbolList() {
      this.idx ++
      let platform = this.getCurrentPlatform(this.idx)

      if (platform !== "") {
        return this.getSymbolListData(platform)
      } else {
        this.idx = -1
        this.getAccountList()

        return Promise.resolve()
      }
    },
    getSymbolListData(platform) {
      return this.$tango.getSymbolList(platform).then(rep => {
        if (rep.resultCode !== 0) {
          throw new Error('ERROR : Instrument List')
        } else {

          var instrumentData = {}

          if (rep.instrumentList && rep.instrumentList.length) {
            instrumentData[platform] = rep.instrumentList
          }
          else {
            instrumentData[platform] = []
          }

          this.addInstrumentList(instrumentData)
          //get next platform
          this.getSymbolList()
        }
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.log(err)
      })
    },
    getAccountList() {
      this.idx ++
      let platform = this.getCurrentPlatform(this.idx)

      if (platform !== "") {
        return this.getAccountListData(platform)
      } else {
        return Promise.resolve()
      }
    },
    getAccountListData(platform) {
      return this.$tango.getAccountList(platform).then(rep => {
        if (rep.resultCode !== 0) {
          throw new Error('ERROR : Account List')
        } else {

          var accountData = {}

          if (rep.dossierList && rep.dossierList.length) {
            //sort by dosName, dosId
            rep.dossierList.sort(function(a, b){
                var dosNameA = a.dosName.toLowerCase()
                var dosNameB = b.dosName.toLowerCase()
                if (dosNameA < dosNameB) //sort string ascending
                    return -1 
                else if (dosNameA > dosNameB)
                    return 1
                // same name => sort by dosId
                else if (a.dosId < b.dosId)
                  return -1
                else if (a.dosId > b.dosId)
                  return 1
                return 0 //default return value (no sorting)
            })

            accountData[platform] = rep.dossierList
          }
          else {
            accountData[platform] = []
          }
          this.addAccountList(accountData)
          //get next platform
          this.getAccountList()
        }
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.log(err)
      })
    },
    getNotificationList () {
      let cond = {
        functionId: 'getNotificationList',
        parameterList: [
          { paramName: 'size', paramValue: 100 },
          { paramName: 'page', paramValue: 1 }
        ]
      }

      return this.$tango.getFunctionData(cond).then(rep => {
        if (rep.resultCode !== 0) {
          throw new Error('ERROR : Notification List')
        } else {
          if (rep.alertList && rep.alertList.length) {
            this.setNotificationList(rep.alertList)
          }
        }
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.log(err)
      })
    }
  }
}
</script>

<style lang="scss">
@import "@/styles/variables.scss";

/* reset element-ui css */
.login-container {

  .el-input {
    display: inline-block;
    height: 45px;
    width: 85%;
    border: unset;

    input {
      background: transparent;
      width: 250px;
      border: 0;
      width: 100%;
      -webkit-appearance: none;
      height: 100%;
    }
  }

  .el-form-item {
    width: 250px;
    margin-bottom: unset;
  }

}
</style>

<style lang="scss" scoped>

.dialog-container {
}

.login-container {
  min-height: 100%;
  width: 100%;
  overflow: hidden;

  .login-form {
    padding: 0px 35px;
    overflow: hidden;

    .login-title {
      font-size: 1.2em;
      text-align: center;
      margin-bottom: 10px;
    }

    .login-text {
      font-size: 1em;
      text-align: center;
      margin-bottom: 10px;
    }
  }

  .tips {
    font-size: 1em;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .login-button  {
    width: 250px;
    height: 45px;
  }

  .svg-container {
    padding: 6px 5px 6px 15px;
    vertical-align: middle;
    width: 30px;
    display: inline-block;

  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 1.2em;
    cursor: pointer;
    user-select: none;
  }

  .loginLogo {
    margin-bottom: 10px;
    background: none no-repeat center;
    background-size: contain;
    height: 100px;
    width:100%;
  }

  .mainLogo {
    background-size: contain;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    height: 40vw;
  }

  .set-language {
    font-size: 1.5em;
  }
}
</style>
